import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_dashboard/site/$id/logbook/$workId/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <div>Hello "/_dashboard/site/$id/logbook/$logId/"!</div>
}
